export default "__VITE_ASSET__C17rtWFu__"